import PropTypes from "prop-types";
import React, { Component } from "react";
import { useLocation } from "react-router-dom";

class NonAuthLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.capitalizeFirstLetter.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    let currentPage = this.capitalizeFirstLetter(this.props.location.pathname);
    document.title = currentPage + " | BLUECPM";
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
};

// ✅ wrapper HOC for v6 (replaces withRouter)
function withRouter(Component) {
  return function Wrapper(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}

export default withRouter(NonAuthLayout);
